import { createContext } from "react";

export interface AppSubBarMenuInterface {
    mobileDrawerOpen: boolean;
    setMobileDrawerOpen: (is: boolean) => void;
}

export const AppSubBarMenuContext = createContext<AppSubBarMenuInterface>(undefined);
